/** Retailer region of the Other retailer, whose pages are scored against the universal benchmark. */
export const OTHER_RETAILER_REGION_ID = 'us_composite_us';

/** Retailer key of the universal benchmark, as score entries and benchmark members carry it. */
export const UNIVERSAL_BENCHMARK_KEY = 'us_composite';

/** The universal benchmark's name in the UI. */
export const UNIVERSAL_BENCHMARK_NAME = 'US E-Commerce';

export function isOtherRetailerRegion(retailerRegionId: string | null | undefined): boolean {
  return retailerRegionId === OTHER_RETAILER_REGION_ID;
}

/** A universal category's breadcrumbs, led by the benchmark name; empty when there are no levels. */
export function universalCategoryBreadcrumbs(levels: readonly string[]): string[] {
  return levels.length ? [UNIVERSAL_BENCHMARK_NAME, ...levels] : [];
}
